import { mallApi } from '../request'
import { apiPath } from '../api'

export const personList = {
  personalInfoList: data => mallApi.post(apiPath.personalPrivacyList, data)
}
